<template>
  <v-dialog :value="open" max-width="520" @input="(v) => !v && $emit('cancel')">
    <v-card>
      <v-form @submit.prevent="$emit('accept', mode)">
        <v-card-title class="headline">Registrar {{ lineas.length }} movimientos del banco</v-card-title>
        <v-card-text>
          <p>
            Seleccionaste {{ lineas.length }} movimientos por un total de
            <span :class="total < 0 ? 'error--text' : ''">{{ formatUtils.formatMoney(total) }}</span>.
            ¿Cómo querés cargarlos en el movimiento de tesorería?
          </p>
          <v-radio-group ref="group" v-model="mode" hide-details class="mt-0" @keydown.enter.native.prevent="$emit('accept', mode)">
            <v-radio value="sum">
              <template v-slot:label>
                <div>
                  <div>Sumado en una línea</div>
                  <div class="caption grey--text text--darken-1">
                    Una línea de banco por el total, con el motivo "{{ lineas.length }} movimientos del banco".
                  </div>
                </div>
              </template>
            </v-radio>
            <v-radio value="line_by_line" class="mt-3">
              <template v-slot:label>
                <div>
                  <div>Línea por línea</div>
                  <div class="caption grey--text text--darken-1">
                    Una línea de banco por el total y una línea por cada movimiento, con su importe y el texto del banco como motivo, para que elijas la cuenta y el concepto.
                  </div>
                </div>
              </template>
            </v-radio>
          </v-radio-group>
          <p class="caption grey--text text--darken-1 mt-4 mb-0">
            En los dos casos se crea un solo movimiento con fecha {{ latestDate }} (la más reciente).
            Podés revisarlo en el paso siguiente.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="error" @click="$emit('cancel')">Cerrar</v-btn>
          <v-btn text color="success" type="submit">Continuar</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { formatUtils } from "@/libs/utils/formatUtils";

export default {
  props: {
    open: Boolean,
    lineas: { type: Array, default: () => [] },
  },
  data() {
    return { formatUtils, mode: "sum" };
  },
  computed: {
    total() {
      return this.lineas.reduce((s, l) => s + l.amount, 0);
    },
    latestDate() {
      const dates = this.lineas.map((l) => l.date).sort();
      return dates.length ? formatUtils.formatDateString(dates[dates.length - 1]) : "";
    },
  },
  watch: {
    open(val) {
      if (!val) return;
      this.mode = "sum";
      //v-dialog toma el foco al abrir: se lo devolvemos al radio seleccionado
      this.$nextTick(() => {
        setTimeout(() => {
          const input = this.$refs.group && this.$refs.group.$el.querySelector("input[type=radio]:checked");
          if (input) input.focus();
        }, 50);
      });
    },
  },
};
</script>
